<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <p>
          Keep an eye on your inbox! Great beer coming to you soon!
        </p>
        <div class="pure-u-g" style="text-align: center;">
          <div class="pure-u-1">
            <img style="width: 209px;height: 209px;" src="../../assets/images/horusSkyGod.png">
          </div>
        </div>
        <p>
          If you have any questions, concerns or comments, please email
          <a href="mailto:support@tavour.com">support@tavour.com</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../lib/store';

export default {
  name: 'SuccessHorusSkyGod',
  created() {
    /* global ga fbq */
    ga('send', 'pageview', `/${store.get('horusSkyGod')}/Success`);

    store.clear();
  },
};
</script>



// WEBPACK FOOTER //
// SuccessHorusSkyGod.vue?01b70070